'use client'

import { createContext, useEffect, useRef } from 'react'
import { RealtimeClient } from '@/lib/realtime/client'

export const RealtimeContext = createContext<RealtimeClient | null>(null)

interface RealtimeProviderProps {
  children: React.ReactNode
  isAuthenticated: boolean
}

export function RealtimeProvider({ children, isAuthenticated }: RealtimeProviderProps) {
  const clientRef = useRef<RealtimeClient | null>(null)

  if (!clientRef.current) {
    clientRef.current = new RealtimeClient()
  }

  const client = clientRef.current

  useEffect(() => {
    if (isAuthenticated) {
      // Small delay to ensure auth is fully settled
      const timer = setTimeout(() => {
        client.connect()
      }, 100)

      return () => clearTimeout(timer)
    } else {
      client.disconnect()
    }
  }, [isAuthenticated, client])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      client.disconnect()
    }
  }, [client])

  return (
    <RealtimeContext.Provider value={client}>
      {children}
    </RealtimeContext.Provider>
  )
}
